import { useDispatch, useSelector } from 'react-redux'
import { Dialog } from '@headlessui/react'
import { ImageComponent } from '../NewPostPaymentFeature/CertificateDownload'
import { selectShowCourseModal, setShowCourseModal } from '../../redux/otherDetailsSlice'
import { selectAddOns, selectMakePersonaliseCourseFree, setPersonalisedSelected } from '../../redux/addOnSlice'
import PersonlaisedCourseSection from '../AddOnPage/PersonlaisedCourseSection'
import { selectPriceChart } from '../../redux/priceChartSlice'


export const BottomPriceSection = ({ selected, setSelect, discountedPrice, originalPrice, showFree=false }) => {

    const dispatch = useDispatch()

    const handleCart = () => {
        if (selected){
            return
        }
        dispatch(setSelect(true))
    }

    return <div className='sticky bg-sticky-bar z-50 left-0 bottom-0 flex justify-between items-center p-3 gap-3'>
        <h2 className='text-lg font-bold text-check-mark'>{showFree ? <span className='py-0.5 px-2 rounded text-xs font-bold text-white' style={{ backgroundImage: 'linear-gradient(45deg, #1983D0 0%, #54A3F5 63%, #75DBFF 100%)'}}>Free</span> : `$${discountedPrice}` } <span className='text-danger text-xs font-medium'>$</span><span className='text-danger text-xs font-medium line-through'>{originalPrice}</span></h2>
        <div className={`flex-1 max-w-[300px] bg-[#7FC241] text-center ${selected && 'opacity-50'} py-2 px-6 rounded-lg font-medium text-black cursor-pointer`} onClick={handleCart}>
            {selected ? 'Added To Cart' : 'Add To Cart'}
        </div>
    </div>
}

export const filledstars = (randomNo) => Array.from({ length: randomNo }, (_, index) => (
    <ImageComponent key={index} source={'https://assets.learntube.ai/files/Post%20Payment/Star.png?updatedAt=1704375792364'} />
))

export const notFilledstars = (randomNo) => Array.from({ length: randomNo === 4.5 ? 1 : 0 }, (_, index) => (
    <ImageComponent key={index} source={'https://assets.learntube.ai/files/Post%20Payment/Star%20(2).png?updatedAt=1704520939066'} />
))


const NewCourseDetailsModal = () => {

    const showCourseModal = useSelector(selectShowCourseModal)
    const addOnDetails = useSelector(selectAddOns)
    const priceChart = useSelector(selectPriceChart)
    const makePersonaliseCourseFree = useSelector(selectMakePersonaliseCourseFree)

    const skillName =  addOnDetails?.skillName
    const rating = addOnDetails?.rating
    const student = addOnDetails?.student
    const personalisedSelected = addOnDetails?.personalisedSelected

    const dispatch = useDispatch()
    
    const handleModal = () => {
        dispatch(setShowCourseModal(false))
    }

    return (
        <div>
            <Dialog
                open={showCourseModal}
                onClose={handleModal}
                as='div'
                className="fixed z-40 inset-0 flex flex-col mx-auto text-white"
            >
                <Dialog.Overlay className="fixed inset-0 m-auto z-50 bg-black opacity-80" />
                <Dialog.Title/>
                <Dialog.Description/>
                <div className='p-[1px] bg-glass-effect m-auto max-w-2xl rounded-2xl w-[90%] z-[80] shadow-[0_0_20px_rgba(0, 0, 0, 0.3)]'>
                    <div className={`bg-custom-bg relative rounded-2xl max-h-[550px] overflow-y-scroll`}>
                        <div className='p-3'>
                            <div className='flex items-start justify-between gap-3'>
                                <div className=''>
                                    <h3 className='text-xl font-bold leading-6 line-clamp-1'>{skillName}</h3>
                                    <div className='flex gap-2 items-center mt-1.5'>
                                        <div className='flex'>
                                            {filledstars(rating)}
                                            {notFilledstars(rating)}
                                        </div>
                                        <p className='text-xs text-white/50 mt-0.5'>{student} Students</p>
                                    </div>
                                </div>
                                <div className='h-fit cursor-pointer' onClick={handleModal}>
                                    <img src="https://assets.learntube.ai/files/New%20Analysis%20Page/Close.svg?updatedAt=1742903383647" width={25} height={25} alt="" />
                                </div>
                            </div>
                            <div className='mt-6'>
                                <PersonlaisedCourseSection skillName={skillName} />
                            </div>
                        </div>
                        <BottomPriceSection
                            selected={personalisedSelected || makePersonaliseCourseFree}
                            setSelect={setPersonalisedSelected}
                            discountedPrice={priceChart[66]?.price}
                            originalPrice={priceChart[66]?.original_price}
                            showFree={makePersonaliseCourseFree}
                        />
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default NewCourseDetailsModal